/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Error_Field_Too_ShortInputs */

const es_co2_error_field_too_short = /** @type {(inputs: Error_Field_Too_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Debe tener al menos ${i?.count} caracteres.`)
};

/**

* @param {Error_Field_Too_ShortInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_field_too_short = /** @type {((inputs: Error_Field_Too_ShortInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Field_Too_ShortInputs, { locale?: "es-CO" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_field_too_short(inputs)
});